import { jobActionTypes } from 'store/actionTypes';
import api from 'utils/api';
import { JOB_STAGE } from '../../constants';

export const getAllJobs = () => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.GET_ALL_JOBS_START });
    const { data } = await api.get('job');
    dispatch({ type: jobActionTypes.GET_ALL_JOBS, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.GET_ALL_JOBS_ERROR, payload: err });
  }
};

export const getJobById = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.GET_JOB_BY_ID_START });
    const { data } = await api.get(`job/${id}`);
    dispatch({ type: jobActionTypes.GET_JOB_BY_ID, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.GET_JOB_BY_ID_ERROR, payload: err });
  }
};

export const sendJobInquiry = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.SEND_JOB_INQUIRY_START });
    const { data } = await api.get(`job/send/${id}`);
    dispatch({ type: jobActionTypes.SEND_JOB_INQUIRY, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.SEND_JOB_INQUIRY_ERROR, payload: err });
  }
};

export const submitJobInquiry = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.SUBMIT_JOB_INQUIRY_START });
    const response = await api.get(`job/submit/${id}`);
    dispatch({ type: jobActionTypes.SUBMIT_JOB_INQUIRY });
    return response;
  } catch (err) {
    dispatch({ type: jobActionTypes.SUBMIT_JOB_INQUIRY_ERROR, payload: err });
  }
};

export const updateJobInquiry = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.UPDATE_JOB_INQUIRY_START });
    const { data } = await api.patch(`/job/inquiry/${id}`, newData);
    dispatch({ type: jobActionTypes.UPDATE_JOB_INQUIRY, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.UPDATE_JOB_INQUIRY_ERROR, payload: err });
  }
};

export const changeJobInquiry = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.CHANGE_JOB_INQUIRY_START });
    const { status } = await api.patch(`/job/inquiry/${id}`, newData);
    if (status === 200) {
      dispatch({ type: jobActionTypes.CHANGE_JOB_INQUIRY });
    } else {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_INQUIRY_ERROR,
        payload: { message: 'Updating error, changeJobInquiry' },
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_INQUIRY_VALIDATION_ERROR,
        payload: err.response.data,
      });
    } else {
      dispatch({ type: jobActionTypes.CHANGE_JOB_INQUIRY_ERROR, payload: err });
    }
  }
};

export const addJobInquiryRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.ADD_JOB_INQUIRY_ROWS_START });
    const { data } = await api.patch(`job/inquiry/add-rows/${id}`, newData);
    dispatch({ type: jobActionTypes.ADD_JOB_INQUIRY_ROWS, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.ADD_JOB_INQUIRY_ROWS_ERROR, payload: err });
  }
};

export const duplicateJobInquiryRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS_START });
    const { data } = await api.patch(`job/inquiry/copy-rows/${id}`, newData);
    dispatch({
      type: jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS_ERROR,
      payload: err,
    });
  }
};

export const updateJobSearchReport = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.UPDATE_JOB_SEARCH_REPORT_START });
    const { data } = await api.patch(`/job/search-report/${id}`, newData);
    dispatch({ type: jobActionTypes.UPDATE_JOB_SEARCH_REPORT, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.UPDATE_JOB_SEARCH_REPORT_ERROR,
      payload: err,
    });
  }
};

export const changeJobSearchReport = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.CHANGE_JOB_SEARCH_REPORT_START });
    const { status } = await api.patch(`/job/search-report/${id}`, newData);
    if (status === 200) {
      dispatch({ type: jobActionTypes.CHANGE_JOB_SEARCH_REPORT });
    } else {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_SEARCH_REPORT_ERROR,
        payload: { message: 'Updating error, changeJobInquiry' },
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_SEARCH_REPORT_VALIDATION_ERROR,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_SEARCH_REPORT_ERROR,
        payload: err,
      });
    }
  }
};

export const addJobSearchReportRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS_START });
    const { data } = await api.patch(
      `job/search-report/add-rows/${id}`,
      newData,
    );
    dispatch({
      type: jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS_ERROR,
      payload: err,
    });
  }
};

export const duplicateJobSearchReportRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS_START });
    const { data } = await api.patch(
      `job/search-report/copy-rows/${id}`,
      newData,
    );
    dispatch({
      type: jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS_ERROR,
      payload: err,
    });
  }
};

export const createNewJob = () => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.CREATE_NEW_JOB_START });
    const { data } = await api.get('/job/new-job');
    dispatch({ type: jobActionTypes.CREATE_NEW_JOB, payload: data });
    return data;
  } catch (err) {
    dispatch({
      type: jobActionTypes.CREATE_NEW_JOB_ERROR,
      payload: err,
    });
  }
};

export const getSearchReportJobs = () => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.GET_SEARCH_REPORT_JOBS_START });
    const { data } = await api.get(`/job/stage/${JOB_STAGE.SEARCH_REPORT}`);
    dispatch({ type: jobActionTypes.GET_SEARCH_REPORT_JOBS, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.GET_SEARCH_REPORT_JOBS_ERROR,
      payload: err,
    });
  }
};

export const assignEmployees = (ID, users) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB_START });
    const { data } = await api.patch(`job/update-team/${ID}`, users);
    dispatch({ type: jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB_ERROR,
      payload: err,
    });
  }
};

export const addSearchReportRowToProduct = (ID, ids) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.ADD_TO_PRODUCT_START });
    const { data } = await api.post(`job/add-to-product/${ID}`, { ids });
    dispatch({ type: jobActionTypes.ADD_TO_PRODUCT, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.ADD_TO_PRODUCT_ERROR, payload: err });
  }
};

export const sendToClient = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.SEND_TO_CLIENT_START });
    const { data } = await api.get(`job/submit-to-client/${id}`);
    dispatch({ type: jobActionTypes.SEND_TO_CLIENT, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.SEND_TO_CLIENT_ERROR, payload: err });
  }
};

export const deleteJobInquiryRows = (jobId, ids) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DELETE_JOB_INQUIRY_ROWS_START });
    const { data } = await api.patch(`job/inquiry/delete-rows/${jobId}`, {
      ids,
    });
    dispatch({
      type: jobActionTypes.DELETE_JOB_INQUIRY_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DELETE_JOB_INQUIRY_ROWS_ERROR,
      payload: err,
    });
  }
};

export const deleteJobSearchReportRows = (jobId, ids) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS_START });
    const { data } = await api.patch(`job/search-report/delete-rows/${jobId}`, {
      ids,
    });
    dispatch({
      type: jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS_ERROR,
      payload: err,
    });
  }
};

export const resetJob = () => dispatch =>
  dispatch({ type: jobActionTypes.RESET_JOB });

export const deleteJobQuoteRows = (jobId, ids) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DELETE_JOB_QUOTE_ROWS_START });
    const { data } = await api.patch(`job/quote/delete-rows/${jobId}`, {
      ids,
    });
    dispatch({ type: jobActionTypes.DELETE_JOB_QUOTE_ROWS, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DELETE_JOB_QUOTE_ROWS_ERROR,
      payload: err,
    });
  }
};

export const addJobQuoteRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.ADD_JOB_QUOTE_ROWS_START });
    const { data } = await api.patch(`job/quote/add-rows/${id}`, newData);
    dispatch({ type: jobActionTypes.ADD_JOB_QUOTE_ROWS, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.ADD_JOB_QUOTE_ROWS_ERROR, payload: err });
  }
};

export const duplicateJobQuoteRows = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS_START });
    const { data } = await api.patch(`job/quote/copy-rows/${id}`, newData);
    dispatch({ type: jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS_ERROR,
      payload: err,
    });
  }
};

export const createQuote = (jobId, ids) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.CREATE_QUOTE_START });
    const { data } = await api.post(`job/create-quote/${jobId}`, { ids });
    dispatch({ type: jobActionTypes.CREATE_QUOTE, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: jobActionTypes.CREATE_QUOTE_ERROR, payload: err });
  }
};

export const sendJobQuote = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.SEND_JOB_QUOTE_START });
    const { data } = await api.get(`job/send-to-manager/${id}`);
    dispatch({ type: jobActionTypes.SEND_JOB_QUOTE, payload: data });
  } catch (err) {
    dispatch({ type: jobActionTypes.SEND_JOB_QUOTE_ERROR, payload: err });
  }
};

export const updateJobQuote = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.UPDATE_JOB_QUOTE_START });
    const { data } = await api.patch(`/job/quote/${id}`, newData);
    dispatch({ type: jobActionTypes.UPDATE_JOB_QUOTE, payload: data });
  } catch (err) {
    dispatch({
      type: jobActionTypes.UPDATE_JOB_QUOTE_ERROR,
      payload: err,
    });
  }
};

export const changeJobQuote = (id, newData) => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.CHANGE_JOB_QUOTE_START });
    const { status } = await api.patch(`/job/quote/${id}`, newData);
    if (status === 200) {
      dispatch({ type: jobActionTypes.CHANGE_JOB_QUOTE });
    } else {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_QUOTE_ERROR,
        payload: { message: 'Updating error, changeJobQuote' },
      });
    }
  } catch (err) {
    if (err?.response?.status === 400) {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_QUOTE_VALIDATION_ERROR,
        payload: err.response.data,
      });
    } else {
      dispatch({
        type: jobActionTypes.CHANGE_JOB_QUOTE_ERROR,
        payload: err,
      });
    }
  }
};

export const deleteJobInquiry = id => async dispatch => {
  try {
    dispatch({ type: jobActionTypes.DELETE_JOB_INQUIRY_START });
    await api.delete(`/job/${id}`);
    dispatch({ type: jobActionTypes.DELETE_JOB_INQUIRY });
  } catch (err) {
    dispatch({
      type: jobActionTypes.DELETE_JOB_INQUIRY_ERROR,
      payload: err,
    });
  }
};
